import React, { Fragment, useState, useEffect } from "react";

import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import ApiSetting from "../../../../../Settings/ApiSettings.json";
import Styles from "../../../../Slices/Mof/Styles.json";
import "../../Dashboard.css";
import axios from "axios";
import AddCircleSharpIcon from "@mui/icons-material/AddCircleSharp";
import RemoveCircleSharpIcon from "@mui/icons-material/RemoveCircleSharp";
import { useGlobalContext } from "../../../../../context";
// import OtherBusinessFormList from "./Co";
import FullScreenDialog from "../../../GeneralComponents/FullScreenDialog";

import { IconButton } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { red } from "@mui/material/colors";
import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import ModeEditOutlineRoundedIcon from "@mui/icons-material/ModeEditOutlineRounded";
import Modal from "@mui/material/Modal";
import CircularIndeterminate from "../../../GeneralComponents/CirularProgress";
import StyledDataGrid from "../../../GeneralComponents/StyledDataGrid";
import "../../../../../assets/css/DG.css";
import Box from "@mui/material/Box";
import Pagination from "@mui/material/Pagination";
import ApiSettings from '../../../../../Settings/ApiSettings.json'
import AddStageTransactionTypeApproval from "./AddStageTransactionTypeApproval";
import UpdateActivityForm from "../Activities/UpdateActivityForm";
import ViewActivity from "../Activities/ViewActivity";
import FactCheckIcon from '@mui/icons-material/FactCheck';
import swal from 'sweetalert';

import Cookies from "universal-cookie";
// import UpdateOtherBusinessForm from "./UpdateOtherBusinessForm";
const cookies = new Cookies();

const urlParams = new URLSearchParams(window.location.search);
const myParam = urlParams.get("id");

const label = { inputProps: { "aria-label": "توقيع المكلف او وكيله" } };

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  border: "none",
  height:700,
  boxShadow: 24,
};



export default function StageTransactionTypeGrid(props) {
  const [loading, setLoading] = useState(false);
  const [inactive, setInactive] = useState(false);
  const [pageSize, setPageSize] = useState(5);
  const [pageNumber, setpageNumber] = useState(1);
  const [selectedObject, setSelectedObject] = useState(null);

  const [activityTotal, setActivityTotal] = useState(0);
  const [activityNumberOfPages, setActivityNumberOfPages] = useState(0);
  const [showBoxOfEditForm, setshowBoxOfEditForm] = useState(false);
  const [showBoxOfViewForm, setshowBoxOfViewForm] = useState(false);
  const {otherBusinessForm,stageTransactionType, fetchData } = useGlobalContext();
  const [showStageTransactionTypeApproval,setShowStageTransactionTypeApproval]=useState(false);
  const [nameOFTransactionType,setNameOFTransactionType]=useState('');

  const [showBoxOfApprovalWithFullScreen,setShowBoxOfApprovalWithFullScreen]=useState(false);

  const [snackBar, setsnackBar] = useState({
    open: false,
    vertical: "bottom",
    horizontal: "center",
    message: "",
    severity: "",
  });
  const [rows, setRow] = useState([]);
  const [reload,setReload]=useState(false);



  const [columns] = useState([
    { field: "id", headerName: "ت", flex: 0.1 },

    {
      field: "transaction_types_name",
      headerName: "نوع  التحويل",
      flex: 1.2,
      renderCell: (rows) => {
        return (
          <div style={{ width: "100%" }}>
            {rows?.row?.transaction_type?.name}
          </div>
        );
      },
    },
    {
      field: "stage_name",
      headerName: "المرحلة",
      flex: 1,
      renderCell: (rows) => {
        return <div style={{ width: "100%" }}>{rows?.row?.stage?.name}</div>;
      },
    },
    {
      field: "order_number",
      headerName: "الترتيب",
      flex: 0.7,
      renderCell: (rows) => {
        return (
          <div style={{ width: "100%" }}>
            {rows?.row?.order_number}
          </div>
        );
      },
    },
 

    {
      field: "actions",
      flex: 1,
      headerName: "الادوات",
      renderCell: (rows) => (
        <strong>
          <IconButton
            style={{ marginLeft: 15 }}
            aria-label="تعديل"
            size="small"
            onClick={() => {
              // updateObject(rows.row);
            }}
          >
            <Tooltip title="Edit">
              <ModeEditOutlineRoundedIcon style={{ fill: "#deb12c" }} />
            </Tooltip>
          </IconButton>

          <IconButton
            style={{ marginLeft: 15 }}
            aria-label="اسناد الموافقات"
            size="small"
            onClick={() => {
              addApproval(rows.row);
            }}
          >
            <Tooltip title="اسناد الموافقات ">
              <FactCheckIcon style={{ fill: "#deb12c" }} />
            </Tooltip>
          </IconButton>

          <IconButton
            style={{ marginLeft: 20 }}
            aria-label="مسح"
            size="small"
            onClick={() => {
              //TODO delete object
              // console.log(rows.row);
              // deleteRow(rows?.row)
            }}
          >
            <Tooltip title="Delete">
              <DeleteRoundedIcon sx={{ color: red[500] }} />
            </Tooltip>
          </IconButton>
        </strong>
      ),
    },
  ]);

  const updateObject = async (object) => {
    setSelectedObject(object);

    setshowBoxOfEditForm(true);
  };
  const viewObject = async (object) => {
    setSelectedObject(object);
    setshowBoxOfViewForm(true);
  };
  const addApproval=async(object)=>{
    setSelectedObject(object);
    setShowStageTransactionTypeApproval(true); 
    // setShowBoxOfApprovalWithFullScreen(true);
  }
  const advanceSearch = () => {
    fetchData("STAGES_TRANSACTION_TYPE", "transaction_types/"+props.object?.id, {
      page: pageNumber,
      page_size: pageSize,
    });
  };

  useEffect(() => {
    advanceSearch();
  }, [pageSize, pageNumber,reload]);
  //Reformatting activity object once activity are loaded
  useEffect(() => {
    if (stageTransactionType && stageTransactionType.data && stageTransactionType.data.length > 0) {
      setRow(stageTransactionType.data);
      setActivityTotal(stageTransactionType.total);
      setActivityNumberOfPages(stageTransactionType.last_page);
      setNameOFTransactionType(stageTransactionType?.data[0]?.transaction_type?.name)
    }
  }, [stageTransactionType]);

  useEffect(() => {
    if (!cookies.get("role_id")) {
      window.location.href = "/";
    }
  }, []);

  const deleteRow=async(row)=>{
    swal({
      title: "هل انت متئكد?",
      text: "بمجرد مسحك لهذا المقتبس لن تستطيع استرجاعه في ما بعد",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
    .then(async(willDelete) => {
      if (willDelete) {
          let data=null;
          try{
            data=await axios({
                method:'delete',
                url:ApiSettings.apiUrl+'/other_businesses_form/delete',
                data:{
                  other_business_id:row?.id
                },
                headers:{
                    'Content-Type':'application/json',
                    Accept:'application/json',
                }
            })

            if(data){
                if(data.data.status==200){
                    
                      swal("تم حذف المقتبس بنجاح", {
                        icon: "success",
                      });
                    
                    advanceSearch()
                    // setsnackBar({
                    //     ...snackBar,
                    //     open: true,
                    //     severity: "success",
                    //     message: data.data.message,
                    //   });
                }else{
                    setsnackBar({
                        ...snackBar,
                        open: true,
                        severity: "warning",
                        message: data.data.message,
                      });
                }
                setLoading(false)
            }else{
                  setLoading(false)
            }
          }
          catch(err){
            setsnackBar({
                ...snackBar,
                open: true,
                severity: "error",
                message: err.message,
              });
            setLoading(false)

          }
      }
  
    });
  }
  const handlePageChange = (newPage) => {
    setpageNumber(newPage + 1);
  };
  const setReloadData = () => {
    setReload(!reload)
  }

  const handleSaveClicked = () => {
    
  }


  return (
    <div className="Dashboard_MOF px-0 mx-0">
    <div className="container-fluid w-100 mx-0 px-0">
      <div className="row rowContainer mx-0">
        <div className="col-md-12 col-xl-12 w-100 d-flex flex-column justify-content-center align-items-end  paddingForm">
          <div
            className={`FormContainer  `}
            style={{
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10,
            }}
          >
       
            {/* <OtherBusinessFormList advanceSearch={advanceSearch} /> */}

            {/* snack alert box here ... */}
            <Snackbar
              open={snackBar.open}
              autoHideDuration={6000}
              onClose={() => {
                setsnackBar({ ...snackBar, open: false });
              }}
              anchorOrigin={{
                vertical: snackBar.vertical,
                horizontal: snackBar.horizontal,
              }}
            >
              <Alert
                onClose={() => {
                  setsnackBar({ ...snackBar, open: false });
                }}
                severity={snackBar.severity}
                sx={{ width: "100%" }}
              >
                {snackBar.message}
              </Alert>
            </Snackbar>
          </div>
          <div
            className={`FormContainer  ${
              props.inactive === false ? "activeSideMenu" : ""
            }`}
            style={{
              height: "calc(100% - 9em)",
              minHeight: 600,
              borderRadius: 10,
            }}
          >
            <StyledDataGrid
              rows={rows}
              columns={columns}
              rowCount={stageTransactionType?.total ? stageTransactionType?.total : 0}
              pageSize={pageSize}
              page={pageNumber - 1}
              onPageSizeChange={(newPageSize) => {
                setPageSize(newPageSize);
              }}
              components={{
                Footer: () => null,
              }}
              rowsPerPageOptions={[5, 10, 20]}
              // pagination
              paginationMode="server"
              onPageChange={(params) => {
                handlePageChange(params);
              }}
            />
            <Box width="45%" m="auto" sx={{ marginTop: "10px" }}>
              <Pagination
                color="primary"
                size="large"
                count={activityNumberOfPages}
                page={pageNumber}
                showFirstButton
                showLastButton
                onChange={(e, p) => {
                  setpageNumber(p);
                }}
              />
            </Box>

            <div
              style={{
                width: "50%",
                position: "absolute",
                top: "100px",
                margin: "0 auto",
                left: "50%",
                top: "50%",
              }}
            >
              {loading && <CircularIndeterminate />}
            </div>
          </div>
        </div>
      
        <Modal
        sx={{
          overflowY: "scroll",
        }}
        disableScrollLock={false}
      keepMounted
      open={showStageTransactionTypeApproval}
      onClose={() => {
        setShowStageTransactionTypeApproval(false);
        // setshowBoxOfViewForm(false);
      }}
      aria-labelledby="keep-mounted-modal-title"
      aria-describedby="keep-mounted-modal-description"
    >
      <Box
        sx={style}
        style={{
          border: "none",
          outline: "none",
          borderRadius: "10px",
          overflow: "scroll",
        }}
        className="modalCroupsCarrier"
      >
        {selectedObject && showStageTransactionTypeApproval&& <AddStageTransactionTypeApproval object={selectedObject} />}
      </Box>
        </Modal>
        {/* <SideMenu inactive={inactive} setInactiveFromProps={setInactive} /> */}
      </div>
    </div>
  </div>
  )
}
